import { Component, DestroyRef, inject } from '@angular/core';
import { UserdataService } from '../../service/userdata.service';
import { serverurl } from '../../../environments/environment';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { AppdataService } from '../../service/appdata.service';
import { Router } from '@angular/router';
import packageJson from '../../../../package.json';
import { HealthService } from '../../service/health.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-home-header',
    standalone: false,

    templateUrl: './home-header.component.html',
    styleUrl: './home-header.component.scss'
})
export class HomeHeaderComponent {
    user: any;
    userAccountMenueIsOpen: boolean = false;
    serverurl = serverurl;
    showHeaderBackButton: boolean = false;

    protected healthService = inject(HealthService);
    private destroyRef = inject(DestroyRef);

    protected appVersion: string = packageJson.version;

    constructor(
        private userdata: UserdataService,
        private auth: AuthandregistryService,
        private appData: AppdataService,
        private router: Router
    ) {
        this.userdata.data.subscribe(data => {
            this.user = data;
        });

        this.appData.showHeaderBackButton.subscribe(data => {
            this.showHeaderBackButton = data;
        });
    }

    toggleUserMenue() {
        this.userAccountMenueIsOpen = !this.userAccountMenueIsOpen;

        if (this.userAccountMenueIsOpen) {
            this.healthService.getServerVersion$()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe();
        }
    }

    gotoFaq() {
        window.open('/faq', '_blank');
    }
    logout() {
        this.toggleUserMenue();
        this.auth.doLogOut();
    }
    switchLanguage() {
        this.toggleUserMenue();
    }
    goOnePageBack() {
        this.appData.showHeaderBackButton.next(false);
        this.appData.showMenue.next(true);
        if (window.location.pathname == '/home/account') {
            this.router.navigate([this.appData.headerBackButtonHref]);
            return;
        }
        window.history.back();
    }
}

